(function () {
    'use strict';

    angular.module('cimerFrontEndApp').directive('reportPrompt', [function () {
        return {
            restrict: 'EA',
            templateUrl: '/Content/Templates/survey/reportPromptTemplate.html',
            scope: {
                prompt: '=reportPrompt',
                onQuestionClick: '&'
            },
            link: function (scope, elements, attrs) {
                scope.isCollapsed = true;
            }
        };

    }]);

}());